import { render } from "./ktTopicCheck.vue?vue&type=template&id=20156d2d&scoped=true"
import script from "./ktTopicCheck.vue?vue&type=script&lang=js"
export * from "./ktTopicCheck.vue?vue&type=script&lang=js"

import "./ktTopicCheck.vue?vue&type=style&index=0&id=20156d2d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20156d2d"]])

export default __exports__